/**
 * @Description
 */
export default {
  meta: {
    title: '拓店任务', // 拓店任务-标准版
  },
};
